module.exports = __webpack_public_path__ + "img/network_blue.188ea82d.png";